<template>
	<div>
		<div class="list-container">
			<div class="table-list list-header">
				<div class="row">
					<div class="column" style="width:80px;">
						<span>序号</span>
					</div>
					<div class="column" style="width:100px;">
						<span>张号</span>
					</div>
					<div class="column" style="width:100px;">
						<span>位置</span>
					</div>
					<div class="column" style="width:100px;">
						<span>联号</span>
					</div>
					<div class="column" style="width:100px;">
						<span>检测面</span>
					</div>
					<div class="column" style="width:150px;">
						<span>缺陷类型</span>
					</div>
					<div class="column" style="width:100px;">
						<span>
							面积(mm<sup>2</sup>)
						</span>
					</div>
					<div class="column" style="width:100px;">
						<span>强度</span>
					</div>
					<div class="column" style="width:100px;">
						<span>判定</span>
					</div>
					<div class="column">
						<span>标记</span>
					</div>
				</div>
			</div>

			<div class="table-container" id="defect_list_table" tabindex="1" @touchmove.prevent>
				<div class="table-list noselect" id="defect_data_table">
					<div
						class="row"
						v-for="(item, index) in dataList"
						v-bind:class="{
							active: selectedIndex == index,
							checked: item.checked,
							good: item.status,
							bad: !item.status,
						}"
						v-bind:key="index"
						v-bind:id="'tr_' + index"
						v-bind:index="10 + index"
						v-on:click="selectedId = item._id.$oid"
					>
						<div class="column index" style="width:80px;">
							<label>
								<input type="checkbox" v-model="item.checked" v-bind:index="10 + index" v-bind:id="'chk_' + index" />
								{{ index + 1 }}
							</label>
						</div>
						<div class="column" style="width:100px;">
							<span v-text="item.sheet_index"></span>
						</div>
						<div class="column" style="width:100px;">
							<span v-text="(item.meter / 1000).toFixed(2)"></span>
						</div>
						<div class="column" style="width:100px;">
							<span v-text="item.col"></span>
						</div>
						<div class="column" style="width:100px;">
							<span v-text="getModelSideText(item.side_index)"></span>
						</div>
						<div class="column" style="width:150px">
							<span v-text="getDefectTypeName(item.type_index, item.type_index_sys)"></span>
						</div>
						<div class="column" style="width:100px;">
							<span v-text="(item.area / 1000).toFixed(2)"></span>
						</div>
						<div class="column" style="width:100px;">
							<span v-text="item.energy"></span>
						</div>
						<div class="column" style="width:100px;">
							<span v-text="item.status ? '好品' : '坏品'"></span>
						</div>
						<div class="column">
							<span v-text="item.remark"></span>
						</div>
					</div>
				</div>
			</div>

			<div v-show="!defectDataLoaded" class="loading">数据加载中...</div>
		</div>
	</div>
</template>

<script>
	import { store } from './store'

	export default {
		data() {
			this.firstLoad = false
			return {
				selectedIndex: -1,
				type: -1,
				status: '',
				tempDataNoSelection: [],
				tableDom: null,
			}
		},
		computed: {
			/**
			 * 所有缺陷记录。
			 */
			dataList() {
				return store.state.filteredDefects
			},
			/**
			 * 缺陷记录是否加载完成。
			 */
			defectDataLoaded() {
				return store.state.defectDataLoaded
			},
			/**
			 * 所有缺陷类型。
			 */
			defectTypes() {
				var list = []
				var types = store.state.defectTypes
				if (types.length > 0) {
					types.forEach((v, i) => {
						var count = store.state.defects.filter(t => t.type_index == v.type_index).length
						if (count > 0) {
							if (list.findIndex(t => t.name == v.name) == -1) {
								list.push({
									label: v.display,
									value: v.type_index,
								})
							}
						}
					})
				}
				return list
			},
			/**
			 * 选中缺陷记录。
			 */
			selectedId: {
				get() {
					return store.state.selectedDefectId
				},
				set(val) {
					store.setSelectedDefectId(val)
				},
			},
		},
		watch: {
			/**
			 * 选择表格行的时候触发行点击事件。
			 */
			selectedId(val) {
				var index = this.dataList.findIndex(t => t._id.$oid == val)
				var row = this.dataList[index]

				this.selectRow(row, index)
			},
		},
		methods: {
			/**
			 * 选择行。
			 */
			selectRow(row, index) {
				this.selectedIndex = index
				// 判断shift是否按下，使用shift进行批量选中。
				if (event) {
					if (event.shiftKey) {
						if (event.shiftKey == 1) {
							row.checked = !row.checked
							this.dataList[index] = row
						}
					}
				}
			},
			/**
			 * 全选。
			 * @param {Boolean} value 选中还是取消
			 */
			selectAll(value) {
				var tempArray = []
				this.dataList.forEach(item => {
					item.checked = value
					tempArray.push(item)
				})
				this.dataList = tempArray
			},
			/**
			 * 下移。
			 */
			arrowDown() {
				if (this.selectedIndex >= this.dataList.length - 1) return
				this.selectedIndex++
				this.selectedId = this.dataList[this.selectedIndex]._id.$oid
				var tr = document.getElementById('tr_' + this.selectedIndex)
				var chk = document.getElementById('chk_' + this.selectedIndex)
				if (chk) {
					if (chk.offsetParent) {
						tr.scrollIntoView(false)
					}
				}
			},
			/**
			 * 上移。
			 */
			arrowUp() {
				if (this.selectedIndex <= 0) return
				this.selectedIndex--

				this.selectedId = this.dataList[this.selectedIndex]._id.$oid
				var tr = document.getElementById('tr_' + this.selectedIndex)
				var chk = document.getElementById('chk_' + this.selectedIndex)
				if (chk) {
					tr.scrollIntoView(false)
				}
			},
			/**
			 * 获取缺陷类型名称。
			 */
			getDefectTypeName(index, sys_index) {
				var defectType = this.defectTypes.find(t => t.value == index)
				if (defectType) {
					return defectType.label
				} else {
					defectType = this.defectTypes.find(t => t.value == sys_index)
					if (defectType) {
						return defectType.label
					}
				}
				return '--'
			},
			/**
			 * 获取检测面文本。
			 */
			getModelSideText(index) {
				var obj = store.state.modelSides.find(t => t.side_index == index)
				if (obj) {
					return obj.name
				}
				return '--'
			},
			/**
			 * 快捷键处理。
			 */
			invokeShortcutKey() {
				var self = this
				document.onkeydown = function(e) {
					const key = window.event.keyCode
					if (key == 40) {
						//下移。
						self.arrowDown()
						e.preventDefault()
					} else if (key == 38) {
						//上移。
						self.arrowUp()
						e.preventDefault()
					} else if (key == 66) {
						//坏品。
						if (self.selectedIndex > -1) {
							self.dataList[self.selectedIndex].checked = true
						}

						store.setDefectsStatus(0)
						e.preventDefault()
					} else if (key == 71) {
						//好品。
						if (self.selectedIndex > -1) {
							self.dataList[self.selectedIndex].checked = true
						}

						store.setDefectsStatus(1)
					}
				}
			},
		},
		mounted() {
			//注册快捷键。
			this.invokeShortcutKey()
		},
		created() {
			var interval = setInterval(() => {
				if (this.dataList.length > 0) {
					this.selectedId = this.dataList[0]._id.$oid

					window.clearInterval(interval)
				}
			}, 500)
		},
	}
</script>

<style lang="less" scoped>
	.list-header {
		border-top: 1px #ccc solid;
		.column:first-child {
			border-left: 1px #ccc solid;
		}
	}
	.table-list {
		width: 100%;
		.row {
			display: flex;
			.column {
				border-right: 1px #dedede solid;

				span {
					font-size: 12px;
					padding: 3px 8px;
					display: block;
				}
			}

			.column:last-child {
				flex: 1;
			}

			.column.index {
				font-size: 12px;

				label {
					color: #aaa;
				}

				input[type='checkbox'] {
					margin-top: 3px;
				}
			}

			.clearfix {
				clear: both;
			}
		}

		.row.bad {
			.column {
				span {
					color: #f00;
				}
			}
		}

		.row.checked {
			background-color: #f0f7ff;
		}

		.row.active {
			background-color: #006ecc;
			.column {
				border-right-color: #006ecc;
				span {
					color: #fff;
				}
			}
		}

		.row.active:hover {
			background-color: #006ecc;
		}

		.row:hover {
			opacity: 0.7;
			background-color: #eee;
		}
	}

	.list-container {
		position: absolute;
		right: 140px;
		left: 0;
		top: 0;
		bottom: 0;
	}
	.control-container {
		position: absolute;
		width: 120px;
		font-size: 10px;
		right: 10px;
		color: blue;
		top: 0;
		bottom: 0;
		overflow: auto;
	}
	.table-container {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		top: 26px;
		overflow: auto;
		border: 1px #ccc solid;
		background-color: #fff;
	}

	.loading {
		position: absolute;
		left: 45%;
		background-color: #4a4a4ab8;
		text-align: center;
		padding: 10px 20px;
		color: #dadada;
		border-radius: 20px;
		top: 50px;
	}
</style>
